import { gql } from '@apollo/client';

export const GET_AUDIT_REPORTS_BY_DATE_RANGE = gql`
  query GetAuditReportsByDateRange($communityId: ID!, $fromDate: String!, $toDate: String!) {
    community(id: $communityId) {
      id
      name
      auditReportsByDateRange(fromDate: $fromDate, toDate: $toDate) {
        id
        type
        createdBy
        createdAt
        lastModifiedBy
        lastModifiedAt
        name
        status
        auditSessionId
        filters {
          timeframe {
            start
            end
          }
          communityId
          auditorIds
        }
        metrics {
          overall {
            precision
            recall
            f1Score
            accuracy
          }
          byLabel {
            label
            metrics {
              precision
              recall
              f1Score
              accuracy
            }
          }
          byCommunity {
            communityId
            metrics {
              precision
              recall
              f1Score
              accuracy
            }
          }
          disagreements {
            count
            percentage
            byCommunity {
              communityId
              count
            }
          }
          labelComparison {
            exactMatchCount
            exactMatchPercentage
            labelsMissingCount
            labelsMissingPercentage
            additionalLabelsCount
            additionalLabelsPercentage
            bothMissingAndAdditionalCount
            bothMissingAndAdditionalPercentage
          }
        }
      }
    }
  }
`;
